<script lang="ts">
	import { Alert, Button, ButtonV2, Container, Icon, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import ExcludeFailureDetection from '../ExcludeFailureDetection.svelte';
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

	export let device,
		timeToReset: number,
		showWarningIncorrectData: boolean = false,
		showAboutAIModelModal = false,
		useNewLayout = false;

	$: ButtonC = useNewLayout ? ButtonV2 : Button;
</script>

<div>
	<Text element="p" styleType="body-small" class="text-bold">
		{$format('ai_notifications', { default: 'AI notifications' })}
	</Text>
	<ExcludeFailureDetection {device} />
	<hr class="divider mt-m mb-m" />
	<Container backgroundColor={useNewLayout ? 'color-0' : undefined}>
		<div class="content-background">
			{#if showWarningIncorrectData}
				<Alert
					class="mb-m"
					heading={$format('alert_ai_model_incorrect_data', {
						default: `The AI ​​Model is resetting. This will take about ${timeToReset} minutes. While the AI ​​model is resetting, the data will be old or not be correct. Please check back later.`,
					})}
				/>
			{/if}
			<div class="">
				<div class="mb-s d-flex align-items-center">
					<Icon class="mr-s icon-ai-color" icon="fas fa-screwdriver-wrench" size="s" />
					<Text element="p" styleType="body-small" class="text-bold">
						{$format('AI Model training', {
							default: 'AI Model training',
						})}</Text
					>
				</div>
				<div>
					<Text element="p" styleType="body-extra-small" class="text-color-muted">
						{@html $format('ai_is_monitoring', {
							default:
								'The AI model is now <span class="text-bold">actively monitoring for potential issues</span> to ensure optimal device performance.',
						})}
						<Text
							element="span"
							styleType="body-extra-small"
							class="text-primary cursor-pointer"
							on:click={() => {
								showAboutAIModelModal = true;
							}}>{$format('link_learn_more', { default: 'Learn more' })}</Text
						>
					</Text>
				</div>
			</div>
			<hr class="divider mt-m mb-m" />
			<div>
				<svelte:component
					this={ButtonC}
					size="m"
					width="full"
					variant="secondary"
					class="mb-s"
					on:click={() => {
						dispatch('resetCancelEraseAIModelData', 'reset');
					}}
					>{$format('reset_ai_training', {
						default: 'Reset AI training',
					})}</svelte:component
				>
				<svelte:component
					this={ButtonC}
					size="m"
					width="full"
					variant="danger-secondary"
					on:click={() => {
						dispatch('resetCancelEraseAIModelData', 'erase');
					}}
					>{$format('erase_data', {
						default: 'Erase AI training data',
					})}
				</svelte:component>
			</div>
		</div>
	</Container>
</div>
